var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsulationFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "70 -0.01 560.01 560.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m120.91 543.03v-395.95l-38.266 21.523c-4.0859 2.3008-9.2578 0.85156-11.555-3.2344-2.2969-4.082-0.84766-9.2578 3.2344-11.555l271.52-152.73c2.582-1.4531 5.7383-1.4531 8.3203 0l271.52 152.73c4.082 2.2969 5.5312 7.4727 3.2344 11.555-2.2969 4.0859-7.4688 5.5352-11.555 3.2344l-38.266-21.523v395.95h42.426c4.6875 0 8.4844 3.7969 8.4844 8.4844s-3.7969 8.4844-8.4844 8.4844h-543.03c-4.6875 0-8.4844-3.7969-8.4844-8.4844s3.7969-8.4844 8.4844-8.4844zm16.969 0h424.24v-67.879h-424.24zm0-84.848h424.24v-320.64l-212.12-119.32-212.12 119.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsulationFloor);
export default __webpack_public_path__ + "static/media/icon-insulation-floor.b86d64cbbd9eb673f530fbb799e3b743.svg";
export { ForwardRef as ReactComponent };